import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useContext } from "react";
import { DashboardContext } from "../../../../DashboardContext/DashboardContextProvider";

const submitForm = async (clientId, projectId, slide11, missingValues) => {
  try {
    let data = {
      additionalInformation: slide11.additionalInformation,
      submitter: slide11.submitter,
      submitterEmail: slide11.submitterEmail,
    };
    let count = 0;
    // Iterate through missing values object
    for (const [slide, values] of Object.entries(missingValues)) {
      if (values.length > 0) count += 1;
      data[`${slide}Missing`] = values.join(", ");
    }
    data["incompleteSlideCount"] = count;
    console.log("SUBMIT FORM DATA: ", data);
    const res = await axios.patch(
      `/api/submit-form/${clientId}/${projectId}/`,
      data,
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    console.log("SUBMIT FORM ERROR: ", error);
    console.log("Error Message: ", error.message);
  }
};

export default function useSubmitForm(
  clientId,
  projectId,
  isReady,
  setIsReady,
  enqueueSnackbar,
  setIsLoading,
  slide11,
  missingValues,
) {
  const { queryClient, isAdmin, navigate, userId } =
    useContext(DashboardContext);

  const submit = useMutation({
    mutationFn: () => {
      if (isReady === false) {
        return;
      } else {
        return submitForm(clientId, projectId, slide11, missingValues);
      }
    },
    onError: (error) => {
      enqueueSnackbar(
        "There was an error submitting the form. Please try again.",
      );
      setIsReady(false);
    },
    onSuccess: (data) => {
      enqueueSnackbar(
        "Questionnaire is successfully submitted and is now pending review from Argus",
        {
          variant: "success",
          autoHideDuration: 3000,
        },
      );
      if (!isAdmin) {
        queryClient.invalidateQueries(["clientRows", clientId, userId]);
        navigate(`/dashboard/client/${clientId}`, { replace: true });
      } else {
        queryClient.invalidateQueries(["adminRows"]);
        navigate("/dashboard/admin", { replace: true });
      }
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });

  return submit;
}
